var _defs, _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _circle, _path10, _rect2, _path11, _path12, _path13, _circle2, _path14, _path15, _path16, _rect3, _path17, _path18, _rect4, _path19, _path20;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBtsLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0e8a44;}.cls-2{fill:#fff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 200,
    height: 200
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M157.63,174.24H41.79a19.08,19.08,0,0,1,0-38.15H157.63a19.08,19.08,0,1,1,0,38.15ZM41.79,140.37a14.8,14.8,0,0,0,0,29.59H157.63a14.8,14.8,0,1,0,0-29.59Z",
    transform: "translate(0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M48.35,162.45a7.29,7.29,0,1,1,7.28-7.29A7.3,7.3,0,0,1,48.35,162.45Zm0-10.29a3,3,0,1,0,3,3A3,3,0,0,0,48.35,152.16Z",
    transform: "translate(0)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M74.12,162.45a7.29,7.29,0,1,1,7.29-7.29A7.3,7.3,0,0,1,74.12,162.45Zm0-10.29a3,3,0,1,0,3,3A3,3,0,0,0,74.12,152.16Z",
    transform: "translate(0)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M99.9,162.45a7.29,7.29,0,1,1,7.28-7.29A7.3,7.3,0,0,1,99.9,162.45Zm0-10.29a3,3,0,1,0,3,3A3,3,0,0,0,99.9,152.16Z",
    transform: "translate(0)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M125.68,162.45a7.29,7.29,0,1,1,7.28-7.29A7.3,7.3,0,0,1,125.68,162.45Zm0-10.29a3,3,0,1,0,3,3A3,3,0,0,0,125.68,152.16Z",
    transform: "translate(0)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M151.46,162.45a7.29,7.29,0,1,1,7.28-7.29A7.29,7.29,0,0,1,151.46,162.45Zm0-10.29a3,3,0,1,0,3,3A3,3,0,0,0,151.46,152.16Z",
    transform: "translate(0)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M84.33,140.37H37.84v-33.6A22.25,22.25,0,0,1,60.06,84.55h2a22.25,22.25,0,0,1,22.22,22.22Zm-42.21-4.28H80.05V106.77A18,18,0,0,0,62.11,88.83h-2a18,18,0,0,0-17.94,17.94Z",
    transform: "translate(0)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M67.83,88.83H54.33V44.08h13.5Zm-9.22-4.28h4.94V48.36H58.61Z",
    transform: "translate(0)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M120.36,64.89l-19.2-19.2A9.14,9.14,0,0,0,94.65,43H67.51V29.5h28.2A20,20,0,0,1,110,35.4L129.9,55.34ZM104.19,42.66l16.17,16.17,3.49-3.49L106.93,38.43a15.74,15.74,0,0,0-11.22-4.65H71.79v4.93H94.65a13.43,13.43,0,0,1,9.54,3.95Z",
    transform: "translate(0)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 61.08,
    cy: 36.25,
    r: 9.97
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M61.08,48.36A12.11,12.11,0,1,1,73.19,36.25,12.13,12.13,0,0,1,61.08,48.36Zm0-19.94a7.83,7.83,0,1,0,7.83,7.83A7.84,7.84,0,0,0,61.08,28.42Z",
    transform: "translate(0)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 116.67,
    y: 54.44,
    width: 33.94,
    height: 28.66,
    transform: "translate(-9.48 114.64) rotate(-45)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M131.77,93.92,108.48,70.63l27-27L158.79,66.9ZM114.53,70.63l17.24,17.24,21-21L135.5,49.66Z",
    transform: "translate(0)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M128.1,99.55a6.68,6.68,0,0,1-4.76-2L104.82,79.07a6.76,6.76,0,0,1,0-9.54l2.79-2.79a2.14,2.14,0,0,1,3,0l25,25a2.14,2.14,0,0,1,0,3l-2.79,2.79A6.71,6.71,0,0,1,128.1,99.55Zm-19-28.27-1.28,1.28a2.46,2.46,0,0,0,0,3.48l18.51,18.51a2.46,2.46,0,0,0,3.48,0l1.28-1.28Z",
    transform: "translate(0)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M158.15,71.42a2.16,2.16,0,0,1-1.52-.63l-25-25a2.15,2.15,0,0,1,0-3l2.8-2.79a6.74,6.74,0,0,1,9.53,0l18.51,18.51a6.74,6.74,0,0,1,0,9.54l-2.79,2.79A2.15,2.15,0,0,1,158.15,71.42Zm-22-27.16,22,22L159.43,65h0a2.46,2.46,0,0,0,0-3.48L140.91,43a2.47,2.47,0,0,0-3.48,0Z",
    transform: "translate(0)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 61.08,
    cy: 36.25,
    r: 3.01
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M71.51,105.83a2.26,2.26,0,0,0-1.29-.38A2.17,2.17,0,0,0,68,107.69a2.29,2.29,0,0,0,.51,1.45l.14.16a9.87,9.87,0,0,1,2.4,6.46,15.54,15.54,0,0,1-.33,3.49,9.95,9.95,0,0,1-19.23,0,15,15,0,0,1-.34-3.49,9.88,9.88,0,0,1,2.41-6.46l.14-.16a2.35,2.35,0,0,0,.51-1.45A2.18,2.18,0,0,0,52,105.45a2.26,2.26,0,0,0-1.29.38,7.6,7.6,0,0,0-.66.74,14.42,14.42,0,1,0,22.17,0A9.19,9.19,0,0,0,71.51,105.83Z",
    transform: "translate(0)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M56.73,101.61a2.61,2.61,0,1,0-2.6-2.6A2.53,2.53,0,0,0,56.73,101.61Z",
    transform: "translate(0)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M65.39,101.61a2.61,2.61,0,1,0-2.6-2.6A2.52,2.52,0,0,0,65.39,101.61Z",
    transform: "translate(0)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 104.09,
    y: 115.22,
    width: 23.01,
    height: 23.01
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M127.11,140.24h-23a2,2,0,0,1-2-2v-23a2,2,0,0,1,2-2h23a2,2,0,0,1,2,2v23A2,2,0,0,1,127.11,140.24Zm-21-4h19v-19h-19Z",
    transform: "translate(0)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M113.75,132a2,2,0,0,1-1.42-.59L108.87,128a2,2,0,1,1,2.84-2.84l2,2,5.74-5.74a2,2,0,1,1,2.84,2.84l-7.16,7.16A2,2,0,0,1,113.75,132Z",
    transform: "translate(0)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 136.71,
    y: 115.22,
    width: 23.01,
    height: 23.01
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M159.72,140.24h-23a2,2,0,0,1-2-2v-23a2,2,0,0,1,2-2h23a2,2,0,0,1,2,2v23A2,2,0,0,1,159.72,140.24Zm-21-4h19v-19h-19Z",
    transform: "translate(0)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M146.36,132a2,2,0,0,1-1.42-.59L141.49,128a2,2,0,0,1,2.84-2.84l2,2,5.74-5.74a2,2,0,0,1,2.84,2.84l-7.16,7.16A2,2,0,0,1,146.36,132Z",
    transform: "translate(0)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtsLogo);
export default __webpack_public_path__ + "static/media/bts_logo.9558b12301d2a47568ca51a3c3f29724.svg";
export { ForwardRef as ReactComponent };